export default "__VITE_PUBLIC_ASSET__a10a01e6__"